const AUDIO_FILES_DIRECTORY = `sounds`;

// А-Я
function getRussianAlphabetSounds() {
  return {
    "А": 1040,
    "Б": 1041,
    "В": 1042,
    "Г": 1043,
    "Д": 1044,
    "Е": 1045,
    "Ё": 1025,
    "Ж": 1046,
    "З": 1047,
    "И": 1048,
    "Й": 1049,
    "К": 1050,
    "Л": 1051,
    "М": 1052,
    "Н": 1053,
    "О": 1054,
    "П": 1055,
    "Р": 1056,
    "С": 1057,
    "Т": 1058,
    "У": 1059,
    "Ф": 1060,
    "Х": 1061,
    "Ц": 1062,
    "Ч": 1063,
    "Ш": 1064,
    "Щ": 1065,
    "Э": 1069,
    "Ю": 1070,
    "Я": 1071,
  };
}

// 1-99 && 100-900
function getNumberSounds() {
  const numberSounds = {};

  for (let i = 1; i <= 99; i++) {
    numberSounds[i] = String(i).padStart(3, '0');
  }

  for (let i = 1; i <= 9; i++) {
    const hundreds = i * 100;
    numberSounds[hundreds] = String(hundreds);
  }

  return numberSounds;
}

function getOtherSounds() {
  const sounds = ['cabinet', 'call', 'cashbox', 'client', 'desk', 'floor', 'go_to_cabinet_number', 'go_to_stand_number', 'go_to_table_number', 'go_to_window_number', 'recall', 'specialist', 'stand', 'ticket', 'visitor', 'visitor_number', 'window'];
  const otherSounds = {};

  for (const sound of sounds) {
    otherSounds[sound] = sound;
  }

  return otherSounds;
}

function getAudioFiles() {
  return {
    ...getNumberSounds(),
    ...getRussianAlphabetSounds(),
    ...getOtherSounds(),
  }
}

const audioDictionary = getAudioFiles();

for (const audioKey in audioDictionary) {
  audioDictionary[audioKey] = `${AUDIO_FILES_DIRECTORY}/${audioDictionary[audioKey]}.mp3`;
}

export default Object.freeze(audioDictionary);